export default function scrubForCleanSite(str: string): string {
  return str.replace(/(cbd)/g, "hemp").replace(/(CBD)/g, "Hemp")
}
